import React from 'react';
export var encoreContextStatus = {
  experimental: 'experimental',
  next: 'next',
  deprecated: 'deprecated'
};
export var encoreContextKeyword = {
  list: 'list',
  chip: 'chip',
  logospotifyadvertising: 'logospotifyadvertising'
};

/**
 * Lifecycle statuses to manage different versions component behavior.
 *
 * Available keys:
 *
 *  - list: `{ next: ['list'] }` will render a new opinionated List component, see [List](https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-list--docs).
 *  - chip: `{ next: ['chip'] }` will render a new Chip component with new features and no trailing margin, see [Chip](https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-chip--docs).
 * @default {}
 */

export var EncoreContextDefault = {
  experimental: [],
  next: [],
  deprecated: [],
  experimental__defaultProps: {}
};
export var hasStatus = function hasStatus(keyword, status) {
  return status.indexOf(keyword) > -1;
};
export var getStatus = function getStatus(keyword, config) {
  var lifecycle = undefined;
  var statusKeys = Object.keys(encoreContextStatus);
  statusKeys.forEach(function (status) {
    if (hasStatus(keyword, config[status])) lifecycle = status;
  });
  return lifecycle;
};
var EncoreContext = /*#__PURE__*/React.createContext(EncoreContextDefault);
EncoreContext.displayName = 'Encore';
export { EncoreContext };